import { Pmdg777MarketingSeo } from "../../../content/templateMarketing/pmdg-777-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import pmdg777Image from "../../images/templates/pmdg-777.jpg";

export const pmdg777Template: AircraftAddonTemplate = {
  type: "aircraft",
  title: "PMDG 777",
  id: "pmdg-777",
  platforms: ["msfs"],
  image: pmdg777Image,
  infoMarketingBlurb: Pmdg777MarketingSeo,
  content: [
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "EFB Setup",
        },
        {
          item: "SimBrief Data",
          setting: "Loaded",
        },
        {
          header: "Flight Deck Setup",
        },
        {
          item: "Battery",
          setting: "On",
        },
        {
          item: "Hydraulic Pumps",
          setting: "Off",
        },
        {
          item: "Windshield Wipers",
          setting: "Off",
        },
        {
          item: "Primary Ext Power",
          setting: "On",
        },
        {
          item: "Secondary Ext Power",
          setting: "On",
        },
        {
          item: "Parking Brake",
          setting: "Set",
        },
        {
          item: "Nav Lights",
          setting: "On",
        },
        {
          item: "Logo Light",
          setting: "As Required",
        },
        {
          item: "ADIRU",
          setting: "On",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Guard Closed",
        },
        {
          item: "EICAS Recall",
          setting: "Checked",
        },
        {
          item: "CDU",
          setting: "Set",
        },
        {
          item: "IFE/Pass Seats",
          setting: "On",
        },
        {
          item: "Cabin Utility",
          setting: "On",
        },
        {
          item: "APU",
          setting: "As Required",
        },
        {
          item: "Window Heat",
          setting: "On",
        },
        {
          item: "Engine Primary Pumps",
          setting: "On",
        },
        {
          item: "Baro Ref",
          setting: "Set",
        },
        {
          item: "ND Traffic",
          setting: "On",
        },
        {
          item: "Flight Director",
          setting: "On",
        },
        {
          item: "Autothrottle",
          setting: "Armed",
        },
        {
          item: "Performance Data",
          setting: "Calculated & Set",
        },
        {
          item: "MCP",
          setting: "Set for Takeoff",
        },
      ],
    },
    {
      title: "Before Start",
      roles: ["beforeFlightStart"],
      content: [
        {
          item: "APU",
          setting: "Started / As Required",
        },
        {
          item: "R Elec Demand Pump",
          setting: "Auto",
        },
        {
          item: "Elec Primary Pump",
          setting: "On",
        },
        {
          item: "L Elec Demand Pump",
          setting: "Auto",
        },
        {
          item: "Air Demand Pump",
          setting: "Auto",
        },
        {
          item: "No Electronics",
          setting: "On",
        },
        {
          item: "Seat Belts",
          setting: "On",
        },
        {
          item: "L & R Fueld Pumps",
          setting: "On",
        },
        {
          item: "Center Fuel Pumps",
          setting: "As Required",
        },
        {
          item: "Beacon Light",
          setting: "On",
        },
        {
          item: "EICAS Recall",
          setting: "Checked",
        },
        {
          item: "Stab Trim",
          setting: "Set",
        },
        {
          item: "Rudder Trim",
          setting: "Neutral",
        },
        {
          item: "Aileron Trim",
          setting: "Neutral",
        },
        {
          item: "Transponder Mode",
          setting: "XPNDR",
        },
      ],
    },
    {
      title: "Pushback & Engine Start",
      roles: ["engineStart"],
      content: [
        {
          item: "Packs",
          setting: "Auto",
        },
        {
          item: "Ground Connections",
          setting: "Released",
        },
        {
          item: "Doors",
          setting: "Closed & Armed",
        },
        {
          item: "Engine 2 Start Selector",
          setting: "Start",
        },
        {
          item: "Engine 2 Fuel Control",
          setting: "Run",
        },
        {
          item: "Engine 2 Parameters",
          setting: "Monitor",
        },
        {
          item: "Engine 1 Start Selector",
          setting: "Start",
        },
        {
          item: "Engine 1 Fuel Control",
          setting: "Run",
        },
        {
          item: "Engine 1 Parameters",
          setting: "Monitor",
        },
      ],
    },
    {
      title: "After Start",
      roles: ["afterEngineStart"],
      content: [
        {
          item: "Flaps",
          setting: "Set for Takeoff",
        },
        {
          item: "Autobrake",
          setting: "RTO",
        },
        {
          item: "Engine Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Flight Controls",
          setting: "Checked",
        },
        {
          item: "APU",
          setting: "Off / As Required",
        },
      ],
    },
    {
      title: "Taxi",
      roles: ["taxi"],
      content: [
        {
          item: "Taxi Light",
          setting: "On",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "As Required",
        },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff"],
      content: [
        {
          item: "Weather Radar",
          setting: "On",
        },
        {
          item: "Terrain Display",
          setting: "On",
        },
        {
          header: "Lineup",
        },
        {
          item: "Transponder",
          setting: "TA/RA",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "On",
        },
        {
          item: "Strobe Lights",
          setting: "On",
        },
        {
          header: "Cleared for Takeoff",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
      ],
    },
    {
      title: "After Takeoff",
      roles: ["takeoff"],
      content: [
        {
          item: "Gear",
          setting: "Up",
        },
        {
          item: "Flaps",
          setting: "Retracted",
        },
        {
          item: "Autobrake",
          setting: "Off",
        },
        {
          header: "Passing 10,000 ft",
        },
        {
          item: "Landing Lights",
          setting: "Off",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "Off",
        },
        {
          item: "Taxi Lights",
          setting: "Off",
        },
        {
          item: "Logo Lights",
          setting: "Off",
        },
        {
          header: "Passing Transition Altitude",
        },
        {
          item: "Altimiters",
          setting: "Std",
        },
      ],
    },
    "page-break",
    {
      title: "Before Descent",
      roles: ["beforeDescent"],
      content: [
        {
          item: "ATIS and Weather",
          setting: "Obtained",
        },
        {
          item: "CDU",
          setting: "Approach & STAR Set",
        },
        {
          item: "CDU",
          setting: "Flaps & Speed Set",
        },
        {
          item: "EICAS Recall",
          setting: "Checked",
        },
        {
          item: "Landing Performance",
          setting: "Calculated",
        },
        {
          item: "Minimums",
          setting: "Set",
        },
        {
          item: "Altimiter",
          setting: "Local Preset",
        },
        {
          item: "Autobrake",
          setting: "As Required",
        },
      ],
    },
    {
      title: "Descent",
      roles: ["descent"],
      content: [
        {
          header: "Passing Transition Altitude",
        },
        {
          item: "Altimiters",
          setting: "Set",
        },
        {
          header: "Passing 10,000 ft",
        },
        {
          item: "No Electronics",
          setting: "On",
        },
        {
          item: "Seat Belts",
          setting: "On",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "Logo Lights",
          setting: "On",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "On",
        },
        {
          item: "Taxi Lights",
          setting: "On",
        },
        {
          item: "Weather Radar",
          setting: "On",
        },
        {
          item: "Terrain Display",
          setting: "On",
        },
      ],
    },
    {
      title: "Landing",
      roles: ["landing"],
      content: [
        {
          item: "Flaps",
          setting: "Set",
        },
        {
          item: "Speedbrake",
          setting: "Armed",
        },
        {
          item: "Gear",
          setting: "Down",
        },
      ],
    },
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        {
          item: "Speedbrake",
          setting: "Stowed",
        },
        {
          item: "Flaps",
          setting: "Up",
        },
        {
          item: "APU",
          setting: "Start",
        },
        {
          item: "Engine Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Landing Lights",
          setting: "Off",
        },
        {
          item: "Strobe Lights",
          setting: "Off",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "As Required",
        },
        {
          item: "Weather Radar",
          setting: "Off",
        },
        {
          item: "Terrain Display",
          setting: "Off",
        },
        {
          item: "Transponder",
          setting: "XPNDR",
        },
        {
          header: "Approaching the Gate",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "Off",
        },
        {
          item: "Taxi Light",
          setting: "Off",
        },
      ],
    },
    {
      title: "Parking",
      roles: ["parking"],
      content: [
        {
          item: "Parking Brake",
          setting: "On",
        },
        {
          item: "APU",
          setting: "Verify Running",
        },
        {
          item: "Fuel Control",
          setting: "Cutoff",
        },
        {
          item: "Hydraulic Pumps",
          setting: "Off",
        },
        {
          item: "Seat Belts",
          setting: "Off",
        },
        {
          item: "No Electronics",
          setting: "Off",
        },
        {
          item: "Fuel Pumps",
          setting: "Off",
        },
        {
          item: "Beacon Light",
          setting: "Off",
        },
        {
          item: "Flight Director",
          setting: "Off",
        },
        {
          item: "Transponder",
          setting: "Stby",
        },
      ],
    },
  ],
};
